import { type PropsWithChildren } from 'react'

type PropTypes = PropsWithChildren

function AuthenticatedLayout ({ children }: PropTypes) {
  return (
    <div className="flex items-center justify-center h-full min-h-0 min-w-0">
      {children}
    </div>
  )
}

export default AuthenticatedLayout
